<script>
import AppHeader from "@/components/ui/AppHeader/index.vue";
import AppBox from "@/components/ui/AppBox/index.vue";
import {mapActions, mapState} from "vuex";
import XTable from "@/components/XTable/index.vue";
import DateUtil from "@/utils/formatDate";
import SaveProjectModal from "@/pages/ProjectManagement/SaveProjectModal.vue";
import Base64 from "@/utils/base64";

export default {
  name: "ProjectManagement",
  components: {SaveProjectModal, XTable, AppHeader, AppBox},
  data() {
    return {
      tableSize: "small",
      layout: "sizes, prev, pager, next",
      firstColumn: false,
      maxHeight: null,
    };
  },
  computed: {
    ...mapState("projectCenter", ["evaluationList", "evaluationListLoading"]),
    ...mapState("user", ["permissionCode"]),
    columns() {
      let self = this;
      let columns = [
        {
          prop: "id",
          label: "id"
        },
        {
          prop: "name",
          label: "项目名称"
        },
        {
          label: "创建时间",
          render(h, scope) {
            return <div>{self.formatDate(scope.row.createTime)}</div>
          }
        }
      ];
      let canEdite = self.permissionCode.has('plugin:project:manager');
      canEdite && columns.push({
        label: "操作",
        fixed: "right",
        render(h, scope) {
          let canEdite = self.permissionCode.has('plugin:project:manager');
          return (
              <div>
                <el-button
                    onClick={() => {
                      self.handleOpenEvaluationList(scope.row);
                    }}
                    size="mini"
                    type="primary"
                    plain
                >
                  查看报告
                </el-button>
                {canEdite &&
                    <el-button
                        onClick={() => {
                          self.handleEdit(scope.row);
                        }}
                        size="mini"
                        type="primary"
                        plain
                    >
                      编辑
                    </el-button>
                }
                {canEdite &&
                    <el-button
                        onClick={() => {
                          self.handleDelete(scope.row);
                        }}
                        size="mini"
                        type="danger"
                        plain
                    >
                      删除
                    </el-button>
                }
              </div>
          );
        },
      })
      return columns;
    }
  },
  methods: {
    ...mapActions("projectCenter", ["getEvaluationList", "deleteEvaluation"]),
    async loadEvaluationList() {
      await this.getEvaluationList({});
    },
    handleOpenEvaluationList(row) {
      this.$router.push({
        name: "ProjectEvaluationList",
        params: {
          projectId: Base64.encode(row.id)
        }
      })
    },
    handleEdit(row) {
      this.$refs.saveProjectModal.initData(row);
      this.$refs.saveProjectModal.visible = true;
    },
    async handleDelete(row) {
      await this.deleteEvaluation({id: row.id})
      await this.loadEvaluationList();
    },
    formatDate(timestamp) {
      return DateUtil.formatDateFromTimestamp(timestamp);
    },
  }
}
</script>

<template>
  <div class="ProjectManagement">
    <AppHeader>培训项目</AppHeader>
    <AppBox>
      <div class="tableFilter">
        <div style="text-align: right">
          <el-button type="primary" plain @click="handleEdit()" v-show="permissionCode.has('plugin:project:manager')">
            新增项目
          </el-button>
        </div>
      </div>
      <XTable
          :api="loadEvaluationList"
          :state="evaluationList"
          :columns="columns"
          :loading="evaluationListLoading"
          :tableSize="tableSize"
          :firstColumn="firstColumn"
          :layout="layout"
          :maxHeight="maxHeight"
      ></XTable>
      <SaveProjectModal ref="saveProjectModal" @evaluationSaved="loadEvaluationList"></SaveProjectModal>
    </AppBox>
  </div>
</template>

<style scoped lang="scss">
.ProjectManagement {
  .appBox {
    height: calc(100vh - 155px);
    min-height: 330px;

    .tableFilter {
      padding-bottom: 20px;

      .el-form-item {
        margin-right: 30px;
      }

      ::v-deep .el-range-separator {
        width: 20px !important;
      }
    }
  }
}
</style>